import { render } from "./elements_form.vue?vue&type=template&id=9c21f4e6"
import script from "./elements_form.vue?vue&type=script&lang=js"
export * from "./elements_form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__